import Http from '@/libs/axios'
import moment from 'moment'
import { filter } from 'postcss-rtl/lib/affected-props'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
  },
  getters: {
    items: state => {
      return state.items
    },
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      items.data.map(item => {
        item.Allow_edit == 'Y' ? item.Allow_edit = true : item.Allow_edit = false

        return item
      })
      state.items = items
    },
    SET_ITEM(state, item){
      state.item = item
    }
  },
  actions: {
    preview(_, params) { return Http.get('holiday/generate/preview', { params }).then(response => response.data) },
    generate(_, payload) { return Http.post('holiday/generate', payload).then(response => response.data) },
    getList({commit}, {params}){
      return new Promise((resolve, reject) => {
        let filterDate = moment(params.filter, "DD/MM/YYYY")
        if(filterDate.isValid()){
          params.filter = filterDate.format('YYYY-MM-DD')
        }
        Http.get('holiday', { params: params }).then(response => {
            commit('SET_ITEM_LIST', response.data)
            resolve()
        }).catch(error => reject(error))
      })
    },

    show({ commit }, { id }){
      return new Promise((resolve, reject) => {
        Http:get(`holiday/${id}`).then(response => {
          commit('SET_ITEM', response.data)
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    create({ }, { payload } ){
      return new Promise((resolve, reject) => {
        payload.HolidayDate = moment(payload.HolidayDate).format('YYYY-MM-DD')
        Http.post('holiday', payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    update({ }, { originalDate, payload } ){
      return new Promise((resolve, reject) => {
        payload.HolidayDate = moment(payload.HolidayDate).format('YYYY-MM-DD')
        Http.put(`holiday/${originalDate}`, payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    destroy({ }, { id } ){
      return new Promise((resolve, reject) => {
        console.log(id)
        id = moment(id).format('YYYY-MM-DD')
        Http.delete(`holiday/${id}`).then(response => {
        resolve(response)
        }).catch(error => reject(error))
      })
    },
  },
}
